import React, { Component } from 'react';
import { Card, ListGroup, Button, Spinner } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import {
    getRecentViews,
    clearRecentViews,
    entityTypeIcons,
    entityTypeLabels
} from '../../../../services/clinicPortalServices/recentViewService';
import Swal from 'sweetalert2';

class RecentItems extends Component {
    constructor(props) {
        super(props);
        this.state = {
            recentViews: [],
            loading: true,
            error: null
        };
    }

    componentDidMount() {
        this.loadRecentViews();
    }

    loadRecentViews = () => {
        const userId = window.localStorage.getItem('USER_ID');
        if (!userId) {
            this.setState({ loading: false, recentViews: [] });
            return;
        }

        this.setState({ loading: true });
        getRecentViews(userId)
            .then((response) => {
                this.setState({
                    recentViews: response.data || [],
                    loading: false,
                    error: null
                });
            })
            .catch((error) => {
                console.error('Error loading recent views:', error);
                this.setState({
                    loading: false,
                    error: 'Failed to load recent items'
                });
            });
    };

    handleClearAll = () => {
        Swal.fire({
            title: 'Clear Recent Items?',
            text: 'This will remove all your recent items history.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Clear All',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const userId = window.localStorage.getItem('USER_ID');
                clearRecentViews(userId).then(() => {
                    this.setState({ recentViews: [] });
                });
            }
        });
    };

    handleItemClick = (item) => {
        if (this.props.history) {
            this.props.history.push(item.route);
        }
    };

    getRelativeTime = (date) => {
        return moment(date).fromNow();
    };

    getEntityIcon = (entityType) => {
        return entityTypeIcons[entityType] || 'fa-file';
    };

    getEntityLabel = (entityType) => {
        return entityTypeLabels[entityType] || entityType;
    };

    render() {
        const { recentViews, loading, error } = this.state;
        const { maxItems = 10 } = this.props;

        const displayItems = recentViews.slice(0, maxItems);

        return (
            <Card className="recent-items-widget">
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <span>
                        <i className="fas fa-history mr-2"></i>
                        Recent Items
                    </span>
                    {recentViews.length > 0 && (
                        <Button variant="link" size="sm" className="p-0 text-muted" onClick={this.handleClearAll}>
                            Clear All
                        </Button>
                    )}
                </Card.Header>
                <Card.Body className="p-0">
                    {loading ? (
                        <div className="text-center py-4">
                            <Spinner animation="border" size="sm" />
                            <span className="ml-2">Loading...</span>
                        </div>
                    ) : error ? (
                        <div className="text-center py-4 text-danger">
                            <i className="fas fa-exclamation-circle mr-2"></i>
                            {error}
                        </div>
                    ) : displayItems.length === 0 ? (
                        <div className="text-center py-4 text-muted">
                            <i className="fas fa-inbox fa-2x mb-2 d-block"></i>
                            No recent items
                        </div>
                    ) : (
                        <ListGroup variant="flush">
                            {displayItems.map((item, index) => (
                                <ListGroup.Item
                                    key={`${item.entity_type}-${item.entity_id}-${index}`}
                                    action
                                    onClick={() => this.handleItemClick(item)}
                                    className="d-flex align-items-center py-2"
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div
                                        className="recent-item-icon mr-3"
                                        style={{
                                            width: '32px',
                                            height: '32px',
                                            borderRadius: '50%',
                                            backgroundColor: '#e9ecef',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <i className={`fas ${this.getEntityIcon(item.entity_type)}`}></i>
                                    </div>
                                    <div className="flex-grow-1 overflow-hidden">
                                        <div
                                            className="recent-item-label text-truncate"
                                            style={{ fontWeight: 500 }}
                                            title={item.entity_label}
                                        >
                                            {item.entity_label}
                                        </div>
                                        <small className="text-muted">
                                            {this.getEntityLabel(item.entity_type)} &bull;{' '}
                                            {this.getRelativeTime(item.viewed_at)}
                                        </small>
                                    </div>
                                    <i className="fas fa-chevron-right text-muted ml-2"></i>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    )}
                </Card.Body>
                {recentViews.length > maxItems && (
                    <Card.Footer className="text-center py-2">
                        <small className="text-muted">Showing {maxItems} of {recentViews.length} items</small>
                    </Card.Footer>
                )}
            </Card>
        );
    }
}

export default withRouter(RecentItems);
